import script from "./ReportsPortfolioRiskTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportsPortfolioRiskTab.vue?vue&type=script&setup=true&lang=ts"

import "./ReportsPortfolioRiskTab.vue?vue&type=style&index=0&id=aad56cec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aad56cec"]])

export default __exports__